import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-firma-digital-dialog',
    templateUrl: './evk-firma-digital-dialog.component.html',
    styleUrls: ['./evk-firma-digital-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EvkFirmaDigitalDialogComponent implements OnInit {

    public datos: any;

    constructor(
        public dialogRef: MatDialogRef<EvkFirmaDigitalDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.datos = data.datos;
    }

    ngOnInit() {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    guardarFirma($event: any) {
        this.dialogRef.close($event);
    }
}
